import { uniqueKey } from 'global/common/keys'
import { getSectionColor } from 'projectSpecific/sports/create/sectionColors'
import React from 'react'
import { Icon, Label } from 'semantic-ui-react'

export const SectionHeader = ({ levelKey, sectionKey }) => {
  // if (sectionKey === 'undefined') {
  //   console.log('levelKey, sectionKey', levelKey, sectionKey)
  // }
  return (
    <div className="match-date-sec sh" key={uniqueKey('mls', 'tm', levelKey, sectionKey)}>
      <div>{_.startCase(sectionKey)}</div>
      {sectionKey && <Label circular size={'tiny'} color={getSectionColor(sectionKey)} />}
    </div>
  )
}

export const LevelHeader = ({ levelKey }) => {
  return (
    <div className="level-header">{_.startCase(levelKey)}</div>
  )
}